import Feature from 'Services/Feature';

const isMarginEnabled = () => {
    return Feature.isEnabled('email-engine') && Feature.isEnabled('add-margin-paragraphs-richtext');
};

const addBrToEmptyPragraphs = (html) => {
    return html.replace(/<p[^>]*><\/p>/g, '<p><br class="ProseMirror-trailingBreak"></p>');
};
const editorClass = () => {
    return isMarginEnabled() ? 'has-margins' : '';
};

export { addBrToEmptyPragraphs, editorClass, isMarginEnabled };
